import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from '../common/Logo';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md border-b border-slate-200/50 py-3 shadow-sm' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center">
        <button onClick={scrollToTop} className="flex items-center space-x-3 group cursor-pointer">
          <Logo className="w-10 h-10" />
          <span className="text-2xl font-bold tracking-tight text-slate-900 leading-none">Valtivo</span>
        </button>

        <div className="hidden md:flex items-center space-x-8">
          <button onClick={() => scrollToSection('roi-calculator')} className="text-sm font-medium text-slate-600 hover:text-slate-900">ROI Calculator</button>
          <button onClick={() => scrollToSection('pricing-section')} className="text-sm font-medium text-slate-600 hover:text-slate-900">Pricing</button>
          <button
            onClick={() => scrollToSection('booking-section')}
            className={`px-5 py-2.5 text-sm font-semibold rounded-full transition-all ${isScrolled ? 'bg-green-700 text-white hover:bg-green-800' : 'bg-white text-slate-900 hover:bg-slate-50 shadow-sm border border-slate-200'}`}
          >
            Start Free Pilot
          </button>
        </div>

        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-slate-900 hover:bg-slate-100 rounded-lg transition-colors">
          <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-b border-slate-200 overflow-hidden absolute w-full"
          >
            <div className="px-6 py-6 shadow-xl space-y-4">
              <div className="space-y-4">
                <button onClick={() => scrollToSection('roi-calculator')} className="block w-full text-left py-2 text-slate-700 font-medium">ROI Calculator</button>
                <button onClick={() => scrollToSection('pricing-section')} className="block w-full text-left py-2 text-slate-700 font-medium">Pricing</button>
              </div>
              <div className="h-px bg-slate-100 my-4"></div>
              <button onClick={() => scrollToSection('booking-section')} className="w-full bg-green-700 text-white py-3 rounded-lg font-medium text-center hover:bg-green-800 transition-colors">
                Start Free Pilot
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;